module.exports = __webpack_public_path__ + "static/media/iStock-1172893099.83c7f833.jpg";